<template>
  <div>
    <el-select :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.salary_currency')" filterable clearable :multiple="multiple"
      :size="size" class="d-block">
      <el-option v-for="(currency,index) in currencies" :key="'currencies-' + index" :label="currency.name" :value="currency.id"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    props: {
        size: {
            default: 'small'
        },
        placeholder: {
            default: null,
        },
        id:{
            default: null
        },
        multiple:{
            type: Boolean,
            default: false,
        }
    },
     watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.currencies && this.currencies.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        currencies: 'currency/inventory'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'currency/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)
        this.selected = e
      }
    },
  }

</script>
